import { clsx } from 'clsx'
import type { PlatformKey } from '@sonder/shared'

/**
 * Brand marks live in public/platforms: Simple Icons (CC0) where available, otherwise the platform's own asset.
 * Each file is used as a mask so every mark renders in the current text color (ink by default), matching the brand.
 */
const FILE: Record<PlatformKey, string> = {
  instagram: 'instagram.svg',
  facebook: 'facebook.svg',
  tiktok: 'tiktok.svg',
  google: 'google.svg',
  yelp: 'yelp.svg',
  linktree: 'linktree.svg',
  opentable: 'opentable.svg',
  resy: 'resy.png',
}

export function PlatformIcon({ platform, className }: { platform: PlatformKey; className?: string }) {
  const mask = `url(/platforms/${FILE[platform]}) center / contain no-repeat`
  return <span aria-hidden="true" className={clsx('inline-block h-5 w-5 shrink-0 bg-current text-ink', className)} style={{ mask, WebkitMask: mask }} />
}
